import { render, staticRenderFns } from "./AutoSaving.vue?vue&type=template&id=731a86b8&scoped=true&"
import script from "./AutoSaving.vue?vue&type=script&lang=js&"
export * from "./AutoSaving.vue?vue&type=script&lang=js&"
import style0 from "./AutoSaving.vue?vue&type=style&index=0&id=731a86b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731a86b8",
  null
  
)

export default component.exports